// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2m-XBI6lEeoe6zQu4b9Dlj","heading":"_3Of2lvSCb26D8sHqQYouEj","title":"_25Aylkl-JJc2mPpH618IY_","chevron":"_2EWjiBaTCMt7TAK2WYUf42","rotated":"PYnZvSR_UTEZ1LWcxO1yl","divider":"_1xXVNFIi1j3E_QKXntW6IG","flexRow":"_209cxNTcBZLouTNzE6vxbq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModuleDescription/ModuleDescription.mod.css
// module id = 1633
// module chunks = 0